import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../../utils/decorators";


@Options({
    template: require("../templates/made-sold-out.njk"),
})
export default class MadeSoldOut extends Marionette.View<Backbone.Model>{

}



// WEBPACK FOOTER //
// ./@modules/button-logic/views/made-sold-out.ts